import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-cream py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-157" data-mp="1j9gwqm2xz77s">
      <div className="mx-auto max-w-3xl px-4" data-id="element-158" data-mp="1nbbwvn94zejz">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-159" data-mp="1naahj6l385wg">
          Elige tu pack
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border border-line bg-panel shadow-lift" data-id="element-160" data-mp="1x8zv4n5yb46w">
          <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-161" data-mp="228colqrbv9ig" />
          <div className="p-6 sm:p-10" data-id="element-162" data-mp="225grg4nb0ov2">
            <span className="inline-flex items-center gap-2 rounded-md bg-skyDeep px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-white" data-id="element-163" data-mp="2vgwtb43jhkj">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-164" data-mp="1mgodt8py15ja" /> Oferta principal
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-165" data-mp="1hpy6hpxyisly">
              <div data-id="element-166" data-mp="1cq3ko0t1gt7r">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-167" data-mp="1crn0xrep349j">{productName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-168" data-mp="17tlecwi28mtb">
                  Los {totalVolumes} tomos + {totalBonuses} bonos estratégicos listos para usar en el aula.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-169" data-mp="20ecyogk0gcoc">
                <span className="text-sm text-muted" data-id="element-170" data-mp="1vgl8ps2xf0ms">
                  Precio regular <span className="line-through" data-id="element-171" data-mp="1rfrl6ztebnuf">{priceBefore}</span>
                </span>
                <p className="mt-1 font-display text-5xl font-extrabold text-gold" data-id="element-172" data-mp="1ri3yv0s4fc1o">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-accent" data-id="element-173" data-mp="k03dtwez9629">Hoy · 50% de descuento</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-174" data-mp="hit7td27o4a5">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-ink" data-id="element-175" data-mp="mft8t9k7egue">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-176" data-mp="7isinahnuty1" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-177" data-mp="3uw4lkl1766jd">
              Quiero el Megapack
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-178" data-mp="3jtj65ep7pdz">
              <span className="inline-flex items-center gap-1.5" data-id="element-179" data-mp="3pxbjrpv9w3z1">
                <LockIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-180" data-mp="3pxutijarrm1z" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-181" data-mp="3c064cz9o5sr4">
                <ZapIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-182" data-mp="3fy3xueah310b" /> Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-183" data-mp="2xbd4gpgq8yp7">
                <ShieldCheckIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-184" data-mp="2sd1wyldwn0a5" /> Garantía 7 días
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-185" data-mp="369orkhidxecw">
              Pagas en USD. Tu plataforma de pago muestra la conversión a tu moneda local automáticamente.
            </p>
          </div>
        </article>
      </div>
    </section>;
}